import React from "react";

const Overview = () => {
  return (
    <div className="bg-[#39699D]">
      <div className="mx-auto max-w-6xl  md:p-10 p-3 space-y-3">
        <div>
          <p className="text-white font-bold text-lg md:text-xl">
            Program Overview
          </p>
        </div>

        <div className="bg-sdbodywhite h-0.5 w-10"></div>

        <div>
          <p className="text-white text-sm md:text-base text-justify">
            The Executive Summer School in Diplomacy and International Relations
            is an intensive one-week executive education programme designed for
            senior leaders, government officials, and professionals in
            international affairs. Combining theoretical insights, practical
            application, and global perspectives, this programme equips
            participants with advanced skills in diplomacy, leadership, and
            international relations. Through expert-led modules, study tours,
            and collaborative learning, participants will explore contemporary
            challenges such as climate diplomacy, migration management, gender
            inclusivity, and governance frameworks. Graduates will emerge with
            the tools to lead in complex international environments and drive
            impactful change in global diplomacy.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Overview;
